(()=>{"use strict";
const form=document.getElementById("AkiltaContactForm");if(!form)return;
const submitButton=form.querySelector(".ak-contact__submit");
const resetSubmitting=()=>{
 if(form.dataset.akSubmitting!=="1"&&!form.hasAttribute("aria-busy"))return;
 delete form.dataset.akSubmitting;form.removeAttribute("aria-busy");
 if(submitButton){submitButton.disabled=false;submitButton.removeAttribute("aria-disabled");if(submitButton.dataset.akOriginalLabel)submitButton.textContent=submitButton.dataset.akOriginalLabel;}
};
if(submitButton){
 submitButton.dataset.akOriginalLabel=submitButton.textContent||"";
 form.addEventListener("submit",event=>{
  if(form.dataset.akSubmitting==="1"){event.preventDefault();return;}
  form.dataset.akSubmitting="1";form.setAttribute("aria-busy","true");
  submitButton.disabled=true;submitButton.setAttribute("aria-disabled","true");
  const locale=(document.documentElement.lang||"").toLowerCase().startsWith("tr");
  submitButton.textContent=locale?"Gönderiliyor…":"Sending…";
 });
 window.addEventListener("pageshow",resetSubmitting);
}
const params=new URLSearchParams(location.search);
const offer=(params.get("offer")||"").trim(),plan=(params.get("plan")||"").trim(),explicitIntent=(params.get("intent")||"").trim();
const offerInput=form.querySelector("[data-ak-contact-offer]"),planInput=form.querySelector("[data-ak-contact-plan]"),intentSelect=form.querySelector("#AkiltaContactIntent");
if(offerInput)offerInput.value=offer.slice(0,120);
if(planInput)planInput.value=plan.slice(0,120);
const offerIntentMap={
 "business-website-essentials":"business_website",
 "business-website-standard":"business_website",
 "business-website-enhanced":"business_website",
 "e-commerce-launch-starter":"ecommerce_launch_rebuild",
 "e-commerce-launch-standard":"ecommerce_launch_rebuild",
 "commerce-improvement-sprint":"commerce_improvement",
 "commerce-rescue":"commerce_rescue",
 "paid-discovery-technical-assessment-ucretli-kesif-teknik-degerlendirme":"paid_discovery",
 "business-automation-sprint":"business_automation",
 "website-commerce-care":"website_care"
};
const candidateIntent=explicitIntent||offerIntentMap[offer]||"";
if(intentSelect&&candidateIntent){
 const option=[...intentSelect.options].find(o=>o.value===candidateIntent);
 if(option)intentSelect.value=candidateIntent;
}
if(!offer&&!plan)return;
const note=document.createElement("div");note.className="ak-contact__attribution";note.setAttribute("role","status");
const locale=(document.documentElement.lang||"").toLowerCase().startsWith("tr");
const offerLabels={
 "business-website-essentials":locale?"Kurumsal Web Sitesi — Temel":"Business Website Essentials",
 "business-website-standard":locale?"Kurumsal Web Sitesi — Standart":"Business Website Standard",
 "business-website-enhanced":locale?"Kurumsal Web Sitesi — Gelişmiş":"Business Website Enhanced",
 "e-commerce-launch-starter":locale?"E-Ticaret Kurulum — Başlangıç":"E-Commerce Launch — Starter",
 "e-commerce-launch-standard":locale?"E-Ticaret Kurulum — Standart":"E-Commerce Launch — Standard",
 "commerce-improvement-sprint":locale?"E-Ticaret İyileştirme Sprinti":"Commerce Improvement Sprint",
 "commerce-rescue":locale?"E-Ticaret Kurtarma":"Commerce Rescue",
 "paid-discovery-technical-assessment-ucretli-kesif-teknik-degerlendirme":locale?"Ücretli Keşif / Teknik Değerlendirme":"Paid Discovery / Technical Assessment",
 "business-automation-sprint":locale?"İş Süreci Otomasyonu Sprinti":"Business Automation Sprint",
 "website-commerce-care":locale?"Web Sitesi & E-Ticaret Bakımı":"Website & Commerce Care"
};
const planLabels={Focused:locale?"Odaklı":"Focused",Standard:locale?"Standart":"Standard",Extended:locale?"Genişletilmiş":"Extended",Starter:locale?"Başlangıç":"Starter",Structured:locale?"Yapılandırılmış":"Structured",Deep:locale?"Derin":"Deep",Essential:locale?"Temel":"Essential"};
const parts=[];if(offer)parts.push((locale?"Teklif":"Offer")+": "+(offerLabels[offer]||offer.replace(/-/g," ")));if(plan)parts.push((locale?"Plan":"Plan")+": "+(planLabels[plan]||plan));
note.textContent=(locale?"Bu form seçiminizi koruyor — ":"This form keeps your selection — ")+parts.join(" · ");
const fields=form.querySelector(".ak-contact__fields");if(fields)form.insertBefore(note,fields);
})();